export const getTagColour = (status) =>
{
  if(status === "CUSTOMER_DRAFT")
  {
      return "purple"
  }
  if(status === "CREATED")
  {
      return "geekblue"
  }
  if(status === "AWAITING_THEFT_REVIEW")
  {
      return "volcano"
  }
  if(status === "THEFT_TOTAL_LOSS")
  {
      return "orangered"
  }
  if(status === "ACCEPTED")
  {
      return "cyan"
  }
  if(status === "ASSESSED_REPAIR")
  {
      return "gold"
  }
  if(status === "AWAITING_REPAIR")
  {
      return "orange"
  }
  if(status === "REPAIR_IN_PROGRESS")
  {
      return "chartreuse"
  }
  if(status === "REPAIR_SUSPENDED")
  {
      return "firebrick"
  }
  if(status === "DAMAGE_TOTAL_LOSS")
  {
      return "black"
  }
  if(status === "REPAIR_COMPLETE")
  {
      return "lime"
  }
  if(status === "COMPLETE")
  {
      return "green"
  }
  if(status === "CANCELLED")
  {
      return "darkgrey"
  }
}